import GeoTagPhotoPage from "pages/photo/pages/GeoTagPhotoPage";

export default function GeoTagPhotoRoute() {
  return <GeoTagPhotoPage />;
}
